import { Component, OnInit, ViewChild } from '@angular/core';
import { InventradaprodService } from '../invservicios/inventradaprod.service';
import { Inventrada } from '../invinterfaces/inventrada';
import { Invencentrada } from '../invinterfaces/invencentrada';
import { InvMaearticulo } from '../invinterfaces/invmaearticulo';
import { ConfirmationService, MessageService, SelectItem } from 'primeng/api';
import { InvbusquedaService } from '../invservicios/invbusqueda.service';
import { ErroresBaseDatosService } from '../../servicios/errores-base-datos.service';
import { CellEditorPrueba } from '../../advantage/config/cell-edit-prueba';
import { AggridsaciComponent } from '../../advantage/aggridsaci/aggridsaci.component';
import { ConfInicialesService } from '../../servicios/conf-iniciales.service';
import { SegMaePermiso } from '../../advantage/advantageinterfaces/segmaepermiso';
import { AuditoriagralService } from '../../advantage/advantageservices/auditoriagral.service';
import { PermisosService } from '../../advantage/advantageservices/permisos.service';
import { NuevoComponentService } from '../../servicios/nuevo-component.service';
import { DatePipe } from '@angular/common';
import { UtilitariosService } from 'src/app/advantage/advantageservices/utilitarios.service';
import { Usuario } from 'src/app/usuario';
import { isNullOrUndefined } from 'util';


@Component({
  selector: 'app-inventradaprod',
  templateUrl: './inventradaprod.component.html',
  styleUrls: ['../../advantage/styles/saciwebtrn.css']
})
export class InventradaprodComponent implements OnInit {
  @ViewChild(AggridsaciComponent) aggrid: AggridsaciComponent;
  hmpConfiguracion: any[];
  indicador: any;
  modulo: any;

  entradas: Inventrada[];
  entradasAux: Inventrada[];

  encEntradas: Invencentrada[];
  entradaSeleccionada: Inventrada;
  encentradaSeleccionada: Invencentrada = {};
  encentradaSeleccionadaAux: Invencentrada;

  permisoEntrada: SegMaePermiso;
  auxiliar: number;
  decimalesPrecioEnt: number;
  decimalesCantidadEnt: number;
  decimalesTotalEnt: number;
  decimalespeso: number;

  botonNuevo: boolean;
  botonNuevoP: boolean;
  botonGuardarP: boolean;
  botonGuardar: boolean;
  botonRegresar: boolean;
  botonRegresarP: boolean;
  barraBotones2: boolean;
  botonPrimero: boolean;
  botonUltimo: boolean;
  botonSiguiente: boolean;
  botonAnterior: boolean;
  botonBorrar: boolean;
  btnNuevoGrid: boolean;
  btnGuardarGrid: boolean;
  btnBorrarGrid: boolean;
  btnCancelarGrid: boolean;
  totalEntrada: number;
  displayAcciones: boolean;
  displayDialogSeriales: boolean;
  strNumFact: any;
  strFechaSer: any;
  asiento: any;
  date1: any;
  hora: any;
  indice: number;
  artNombre: InvMaearticulo;
  opcion: string;
  types: SelectItem[];
  arregloCons: any[];
  displayDialogBusqueda: boolean;
  displayDialogBusquedaFast: boolean;
  displayDialogAsiento: boolean;
  displayAsiContable: boolean;
  displayDialogLotes: boolean;
  spin = false;//CDPJ
  ACEDCVINV: boolean;
  COSENXPESO: boolean;

  control = 0;
  auxiliarlot = 0;

  checkSaldoI: boolean;
  busquedacampos: string[];
  tabla: string;
  where: string;
  activeIndex: number;
  inputsBoolean: boolean;
  largo: string;
  public frameworkComponents;
  rowStyle;
  defaultColDefEntrada;
  defaultColDefEntradaVar;
  rowSelection = 'multiple';

  auxreporte: number = 0;
  strNombreForma: string;
  displayDialogReportes: boolean;

  displayDialogDocumentos = false;
  boolpercont
  displaydistribucion = false;

  columnDefsEntrada = [
    { // 0
      headerName: 'Bodega', field: 'BOD_CODIGO', cellEditor: 'cellPrueba',
      // editable: false,
      cellEditorParams:
      {
        values: {
          mayusculas: true,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 10,
          obligatorio: true,
          fecha: false,
          tamanocelda: 10,
          opcionbuscar: true
        }
      }
    },
    { // 1
      headerName: 'Artículo', field: 'ART_CODIGO', cellEditor: 'cellPrueba',
      // , editable: true,
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          tamanocelda: 25,
          opcionbuscar: true
        }
      }
    },
    { // 2
      headerName: 'Nombre', field: 'ART_NOMBRE', cellEditor: 'cellPrueba',
      // , editable: true,
      cellEditorParams:
      {
        values: {
          mayusculas: true,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 80
        }
      }
    },
    { // 3
      headerName: 'Documento', field: 'DETKAR_NRODOC', editable: true,
      // , editable: true,
      cellEditorParams:
      {
        values: {
          mayusculas: true,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          tamanocelda: 45
        }
      }
    },
    { // 4
      headerName: 'Cantidad', field: 'DETKAR_CANTIDAD', cellEditor: 'cellPrueba', cellStyle: { textAlign: 'right' },
      // , editable: true,
      onCellClicked: (params) => {
        this.abrirLotes(params.data);
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true,
          int: true
        }
      }
    },
    { // 5
      headerName: 'Costo', field: 'DETKAR_COSTOUNIT', cellEditor: 'cellPrueba', cellStyle: { textAlign: 'right' },
      // , editable: true,
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true,
          int: true
        }
      }
    },
    { // 6
      headerName: 'Costo Total', field: 'DETKAR_COSTOTOTAL', cellEditor: 'cellPrueba', editable: false, cellStyle: { textAlign: 'right' },
      // , editable: true,
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: true,
          fecha: false,
          tamanocelda: 32
        }
      }
    },
    { // 7
      headerName: 'C.Costos', field: 'CEN_CODIGO', cellEditor: 'cellPrueba',
      // , editable: true,
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: true,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 0,
          obligatorio: false,
          fecha: false,
          opcionbuscar: true,
          tamanocelda: 35
        }
      }
    },
    { // 8
      headerName: 'Peso', field: 'DETKAR_PESO', cellEditor: 'cellPrueba', cellStyle: { textAlign: 'right' },
      // , editable: true,
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true,
          int: true
        }
      }
    },
    { // 9
      headerName: 'Ponderado', field: 'DETKAR_PONDERADO', cellEditor: 'cellPrueba', cellStyle: { textAlign: 'right' },
      // , editable: true,
      editable: (params) => {
        return false;
      },
      cellEditorParams:
      {
        values: {
          mayusculas: false,
          numeros: true,
          alphabetic: false,
          saltoslinea: 1,
          newrow: false,
          numerodecimales: 2,
          obligatorio: false,
          fecha: false,
          tamanocelda: 32,
          tienecalculos: true,
          int: true
        }
      }
    },
    // { // 10
    //   headerName: 'Cod. Centro Trabajo', field: 'CENTRA_CODIGO', cellEditor: 'cellPrueba', width: 190,
    //   // editable: true,
    //   cellEditorParams:
    //   {
    //     values: {
    //       mayusculas: false,
    //       numeros: true,
    //       alphabetic: true,
    //       saltoslinea: 0,
    //       newrow: false,
    //       numerodecimales: 0,
    //       obligatorio: true,
    //       fecha: false,
    //       clave: false,
    //       tamanocelda: 10,
    //       opcionbuscar: true
    //     }
    //   }
    // },

  ];
  constructor(
    public entradaService: InventradaprodService, private busquedaSer: InvbusquedaService,
    private datePipe: DatePipe, private messageService: MessageService,
    private errorService: ErroresBaseDatosService, private confirmationService: ConfirmationService,
    private confIniciales: ConfInicialesService, private auditoriagral: AuditoriagralService,
    private permisosService: PermisosService, private init: NuevoComponentService,
    private utilitariosService: UtilitariosService, public usuario: Usuario
  ) {
    this.agTable();
  }
  agTable() {
    this.frameworkComponents = {
      cellPrueba: CellEditorPrueba
    };

    this.rowStyle = (params) => {
      if (params.node.rowIndex % 2 !== 0) {
        return { background: '#D6EAF8' };
      }
    };
    this.defaultColDefEntrada = {
      editable: true,
      width: 150,
      objeto: 'maeentradaprod'
    };

  }
  ngOnInit() {
    this.indicador = this.init.tabs[this.init.tabindex - 1].indice;
    this.modulo = 'PROD'
    this.entradaService.detkardexarray[this.indicador] = [];
    this.auxiliar = 0;
    this.tabla = '';
    this.displayAcciones = false;
    this.displayDialogSeriales = false;
    this.spin = false//CDPJ
    this.busquedacampos = [];
    this.botonesguardar();
    this.botonNuevoP = false;
    this.botonGuardarP = true;
    this.botonRegresarP = true;
    this.btnNuevoGrid = true;
    this.btnGuardarGrid = true;
    this.btnCancelarGrid = true;
    this.btnBorrarGrid = true;
    this.barraBotones2 = false;
    this.totalEntrada = 0;
    this.entradas = [];
    this.activeIndex = 0;

    this.indice = 0;
    this.artNombre = {};
    this.checkSaldoI = false;
    this.opcion = '';
    this.date1 = new Date();
    this.hora = new Date();
    this.displayDialogBusqueda = false;
    this.displayDialogBusquedaFast = false;
    this.displayDialogAsiento = false;
    this.displayAsiContable = false;
    this.displayDialogLotes = false;
    this.entradaSeleccionada = {};
    this.encentradaSeleccionada = {};
    this.inputsBoolean = true;
    this.largo = '-5800';
    this.asiento = '';
    this.confIniciales.getDecimales('frmINV_ENCKARDEX').subscribe((dec) => {
      if (dec !== null) {
        dec.map((decimales) => {
          if (decimales.NUMDEC_CAMPO === 'COSTO') {
            this.decimalesPrecioEnt = Number(decimales.NUMDEC_NUMDEC);
            this.entradaService.decimalesPrecioEnt = this.decimalesPrecioEnt;
          } else if (decimales.NUMDEC_CAMPO === 'COSTOTOTAL') {
            this.decimalesTotalEnt = Number(decimales.NUMDEC_NUMDEC);
            this.entradaService.decimalesTotalEnt = this.decimalesTotalEnt;
          } else if (decimales.NUMDEC_CAMPO === 'CANTIDAD') {
            this.decimalesCantidadEnt = Number(decimales.NUMDEC_NUMDEC);
            this.entradaService.decimalesCantidadEnt = this.decimalesCantidadEnt;
          } else if (decimales.NUMDEC_CAMPO === 'PESO') {
            this.decimalespeso = Number(decimales.NUMDEC_NUMDEC);
            this.entradaService.decimalespeso = this.decimalespeso;
          }
        });

        this.columnDefsEntrada[4].cellEditorParams = {
          values: {
            mayusculas: false,
            numeros: true,
            alphabetic: false,
            saltoslinea: 1,
            newrow: false,
            numerodecimales: this.entradaService.decimalesCantidadEnt,
            obligatorio: false,
            fecha: false,
            tamanocelda: 32,
            tienecalculos: true,
            int: true
          }
        };

        this.columnDefsEntrada[5].cellEditorParams = {
          values: {
            mayusculas: false,
            numeros: true,
            alphabetic: false,
            saltoslinea: 1,
            newrow: false,
            numerodecimales: this.entradaService.decimalesPrecioEnt,
            obligatorio: false,
            fecha: false,
            tamanocelda: 32,
            tienecalculos: true,
            int: true
          }
        };

        this.columnDefsEntrada[6].cellEditorParams = {
          values: {
            mayusculas: false,
            numeros: true,
            alphabetic: false,
            saltoslinea: 1,
            newrow: false,
            numerodecimales: this.entradaService.decimalesTotalEnt,
            obligatorio: false,
            fecha: false,
            tamanocelda: 32
          }
        };
        this.columnDefsEntrada[8].cellEditorParams = {
          values: {
            mayusculas: false,
            numeros: true,
            alphabetic: false,
            saltoslinea: 1,
            newrow: false,
            numerodecimales: this.entradaService.decimalespeso,
            obligatorio: false,
            fecha: false,
            tamanocelda: 32,
            tienecalculos: true,
            int: true
          }
        };
        this.columnDefsEntrada[9].cellEditorParams = {
          values: {
            mayusculas: false,
            numeros: true,
            alphabetic: false,
            saltoslinea: 1,
            newrow: false,
            numerodecimales: this.entradaService.decimalesPrecioEnt,
            obligatorio: false,
            fecha: false,
            tamanocelda: 32,
            tienecalculos: true,
            int: true
          }
        };
        this.aggrid.refreshColumnDefs();
      }
    });
    this.permisosService.getListaPermisos('PROD', '6', '501').subscribe((permiso) => {
      this.permisoEntrada = permiso[0];
    });

    this.entradaService.getEncEntradas().subscribe((res) => {
      this.encEntradas = res;
    });
    this.getConfiguracion();
  }
  getConfiguracion() {
    this.auditoriagral.obtenerConfiguracion1().subscribe((conf) => {
      this.hmpConfiguracion = conf;
      this.entradaService.hmpConfiguracion = conf;
      const ccpies = this.hmpConfiguracion.find(element => element.CFG_CODIGO === 'CCPIES').CFG_VALOR1;
      //CDPJ
      this.ACEDCVINV = (this.hmpConfiguracion.find(element => element.CFG_CODIGO === 'ACEDCVINV').CFG_VALOR1) === 1;
      this.COSENXPESO = (this.hmpConfiguracion.find(element => element.CFG_CODIGO === 'COSENXPESO').CFG_VALOR1) === 1;
      if (this.COSENXPESO === false) {
        this.columnDefsEntrada.splice(8, 2);

      }
      if (ccpies === 0 || ccpies === null || ccpies === undefined) {
        this.columnDefsEntrada.splice(7, 1);
      }
      //CDPJ
      this.aggrid.refreshColumnDefs();

    });
  }
  botonesguardar() {
    this.botonNuevo = false;
    this.botonGuardar = true;
    this.botonBorrar = false;
    this.botonRegresar = true;
    this.botonPrimero = false;
    this.botonAnterior = false;
    this.botonSiguiente = false;
    this.botonUltimo = false;
  }
  async manejarSenales(valor) {
    if (valor !== 'Nuevo' && valor !== 'Cancelar'
      && valor !== 'Primero' && valor !== 'Anterior' && valor !== 'Siguiente' && valor !== 'Ultimo'
      && valor !== 'Buscar' && valor !== 'Imprimir' && valor !== 'AsientoVer' && valor !== 'Salir'
      && valor !== 'Almacenardoc') {
      // Verifica el periodo contable
      const dia = this.date1.getDate();
      const mes = this.date1.getMonth();
      const anio = this.date1.getFullYear();


      if (await this.utilitariosService.verificarPeriodoContable(dia, mes, anio) === false) {
        this.messageService.add({
          key: 'entprod',
          severity: 'info',
          summary: 'Información',
          detail: 'Error, fecha debe de estar dentro del período contable'
        });
        return;
      }
    }

    if (valor === 'Nuevo') {

      this.nuevo();
    }


    if (valor === 'Borrar') {
      this.eliminar();
    }


    if (valor === 'Guardar') {
      if (this.control === 0) {
        this.control = 1
        let prodin = 0;
        let pondera = 0
        const centrotrab = [this.encentradaSeleccionada.CENTRA_CODIGO]
        //Array.from(new Set(this.encentradaSeleccionada.map(item => String(item.CENTRA_CODIGO)).filter(x => x !== null && String(x).trim() !== '')));
        const data = await this.entradaService.validacentrabjo(centrotrab, this.encentradaSeleccionada.ENCORDPRO_NUMERO)

        if (this.modulo === 'PROD') {
          const rs = await this.entradaService.ValidaEnSaOrdProd(this.encentradaSeleccionada);
          const rs1 = await this.entradaService.ValidaPonderacion(this.encentradaSeleccionada);


          //console.log('rs',rs)
          if (rs !== null && rs !== undefined) {
            for (const data of rs) {
              prodin = data.NUMERO
            }
          }
          if (rs1 !== null && rs1 !== undefined) {
            for (const data of rs1) {
              pondera = data.NUMERO
            }
          }
        }
        if (this.modulo === 'PROD' && prodin > 0) {
          this.messageService.add({
            key: 'entprod',
            severity: 'error',
            summary: 'Eliminación de Entrada',
            detail: 'No se puede editar la entrada ya que la Orden de Producción está ingresada'
          });
          this.control = 0
          return;
        }
        if (pondera > 0) {
          this.messageService.add({
            key: 'entprod',
            severity: 'error',
            summary: 'Eliminación de Entrada',
            detail: 'No se puede editar la entrada ya que se encuentra ponderada '
          });
          this.control = 0
          return;
        }
        if (data !== null && Object.keys(data).length > 0) {
          if (data.length > 0) {
            this.messageService.add({
              key: 'entprod',
              severity: 'error',
              summary: 'Error',
              detail: 'Hubo un error al validar los siguientes centros de trabajo, ' +
                'por favor revisar que estén regitrados en la pestaña de Centros de trabajo, en el módulo de ordenes de producción procesos ' + data.join(", ")
            });
            this.control = 0;
            this.spin = false
            return;
          }
        }
        this.guardar();
      }
      //this.guardar();
    }


    if (valor === 'Buscar') {

      this.buscar();

    }


    if (valor === 'Primero') {
      this.indice = 0;
      if (this.botonUltimo === true) {
        this.botonUltimo = !this.botonUltimo;
      }
      if (this.botonSiguiente === true) {
        this.botonSiguiente = !this.botonSiguiente;
      }
      this.botonPrimero = true;
      this.botonAnterior = true;
      this.encentradaSeleccionada = this.encEntradas[0];
      this.inputsBoolean = false;
      this.botonBorrar = false;
      if (this.activeIndex === 1) {
        this.activeIndex = 0;
      }
      this.obtenerDatos();
    }

    if (valor === 'Ultimo') {
      this.inputsBoolean = false;
      this.indice = this.encEntradas.length - 1;
      this.encentradaSeleccionada = this.encEntradas[this.indice];
      if (this.botonPrimero === true) {
        this.botonPrimero = !this.botonPrimero;
      }
      if (this.botonAnterior === true) {
        this.botonAnterior = !this.botonAnterior;
      }
      this.botonSiguiente = true;
      this.botonUltimo = true;
      this.obtenerDatos();

      //CDPJ

    }

    if (valor === 'Anterior') {

      this.botonBorrar = false;
      this.inputsBoolean = false;
      this.indice--;
      this.encentradaSeleccionada = this.encEntradas[this.indice];
      if (this.botonUltimo === true && this.botonSiguiente === true) {
        this.botonUltimo = false;
        this.botonSiguiente = false;
      }
      if (this.indice <= 0) {
        this.botonPrimero = true;
        this.botonAnterior = true;
        if (this.indice === 0) {
          this.obtenerDatos();
        } else {
          return;
        }
      } else {
        this.obtenerDatos();
      }



    }

    if (valor === 'Siguiente') {

      this.inputsBoolean = false;
      this.indice++;
      this.encentradaSeleccionada = this.encEntradas[this.indice];
      if (this.botonPrimero === true && this.botonAnterior === true) {
        this.botonPrimero = false;
        this.botonAnterior = false;
      }
      if (this.indice >= this.encEntradas.length - 1) {
        this.botonUltimo = true;
        this.botonSiguiente = true;
        if (this.indice === this.encEntradas.length - 1) {
          this.obtenerDatos();
        } else {
          return;
        }
      } else {
        this.obtenerDatos();
      }



    }

    if (valor === 'Cancelar') {
      this.botonesguardar();
      this.encEntradas = [];
      this.entradaService.getEncEntradas().subscribe((res) => {
        this.encEntradas = res;
        for (const a in this.encEntradas) {
          if (this.encEntradas[a].KAR_NRO === this.encentradaSeleccionada.KAR_NRO) {
            this.encentradaSeleccionadaAux = this.encEntradas[a];
          }
        }
        if (this.encentradaSeleccionada.KAR_NRO !== '' && this.encentradaSeleccionada.KAR_NRO !== null &&
          this.encentradaSeleccionada.KAR_NRO !== undefined) {
          this.encentradaSeleccionada = this.encentradaSeleccionadaAux;
          this.obtenerDatos();
        } else {
          this.nuevoEncEntrada();
          this.botonesguardar();
        }
      });
    }

    if (valor === 'Asiento') {
      await this.generarAsientoPod();

    }

    if (valor === 'AsientoVer') {
      //if (this.modulo !== 'PROD') {
      this.entradaService.getAsiento(this.encentradaSeleccionada).subscribe((res) => {
        this.encentradaSeleccionada.ASI_NRO = res[0].ASI_NRO;
        this.asiento = res[0].ASI_NRO;
        if (this.asiento === null) {
          this.messageService.add({
            key: 'entprod',
            severity: 'error',
            summary: 'Visualizacion de Asiento Contable',
            detail: 'Esta entrada no tiene un asiento contable'
          });
        } else {
          this.auxiliar++;
          // this.displayDialogAsiento = true;
          this.displayAsiContable = true;
        }
      });
      //}
    }

    if (valor === 'Salir') {

      this.init.tabs.splice(this.init.tabindex, 1);



    }

    if (valor === 'Imprimir') {
      this.strNombreForma = this.init.tabs[this.init.tabindex].component;
      this.auxreporte++;
      this.displayDialogReportes = true;
    }

    if (valor === 'Almacenardoc') {
      if (this.encentradaSeleccionada.KAR_NRO !== '') {
        const dia = this.date1.getDate();
        const mes = this.date1.getMonth();
        const anio = this.date1.getFullYear();


        if (await this.utilitariosService.verificarPeriodoContable(dia, mes, anio) === false) {
          this.boolpercont = true;
        } else {
          this.boolpercont = false;
        }
        const usu = await this.confIniciales.obtenerPermisoUsuario(this.usuario.identificacion);
        if (usu[0].USU_ALMACENARDOC === 1 || usu[0].USU_VISUALIZARDOC === 1) {
          this.displayDialogDocumentos = true;
        } else {
          this.messageService.add({
            key: 'entprod',
            severity: 'info',
            summary: 'Información',
            detail: 'No tiene los permisos necesarios. Consulte con el Administrador del Sistema'
          });
        }

      }
    }
    if (valor === 'Ponderar') {
      this.spin = true;
      if (isNullOrUndefined(this.encentradaSeleccionada.KAR_NRO) || this.encentradaSeleccionada.KAR_NRO === '') {
        this.messageService.add({
          key: 'entprod',
          severity: 'error',
          summary: 'Eliminación de Entrada',
          detail: 'Debe guardar primero la entrada'
        });
        this.spin = false;
        return;

      }
      if (isNullOrUndefined(this.encentradaSeleccionada.ENCORDPRO_NUMERO) || this.encentradaSeleccionada.ENCORDPRO_NUMERO === '') {
        this.messageService.add({
          key: 'entprod',
          severity: 'error',
          summary: 'Eliminación de Entrada',
          detail: 'Debe seleccionar una orden de producción'
        });
        this.spin = false;
        return;

      }
      this.poderar()
    }
  }
  async poderar() {
    try {
      await this.entradaService.ponderar(this.encentradaSeleccionada.KAR_NRO);

      await this.auditoriagral.registrarAuditoria('INV_ENCKARDEX', 'BOTON-EJECUTAR-PONDERACIÓN' + '/KarNro:' + this.encentradaSeleccionada.KAR_NRO, 'A',
        '', '01', '', '', '', '').toPromise()
      await this.manejarSenales('Cancelar');
      this.spin = false;
      this.messageService.add({
        key: 'entprod',
        severity: 'success',
        summary: 'Información',
        detail: 'Proceso ejecutado con éxito'
      });
    } catch (e) {
      let mensaje = ''
      mensaje = this.errorService.generarMensajeErrorCompleto(e.error)
      this.messageService.add({
        key: 'entprod',
        severity: 'error',
        summary: 'Ponderar',
        detail: 'Error: ' + mensaje
      });
      this.spin = false;
      return;
    }
  }
  obtenerDatos() {
    //CDPJ
    this.btnNuevoGrid = false;
    this.btnBorrarGrid = false;
    this.btnCancelarGrid = false;
    this.control = 0;
    if (this.encentradaSeleccionada.KAR_SALDOINI === 'S') {
      this.checkSaldoI = true;
    } else if (this.encentradaSeleccionada.KAR_SALDOINI !== 'S') {
      this.checkSaldoI = false;
    }

    this.date1 = new Date(this.encentradaSeleccionada.KAR_FECHA);
    this.hora = new Date(this.encentradaSeleccionada.KAR_FECHA);
    if (this.encentradaSeleccionada.KAR_HORA.toString().length === 4) {
      const separador = ':';
      const arregloHora = this.encentradaSeleccionada.KAR_HORA.toString().split(separador);
      for (let i = 0; i < arregloHora.length; i++) {
        if (arregloHora[i].length !== 2) {
          arregloHora[i] = '0' + arregloHora[i];
        }
      }
      const horaDefinitiva = arregloHora.join(':');
      this.encentradaSeleccionada.KAR_HORA = horaDefinitiva;
    } else if (this.encentradaSeleccionada.KAR_HORA.toString().length === 3) {
      this.encentradaSeleccionada.KAR_HORA = '0' + this.encentradaSeleccionada.KAR_HORA.toString();
      this.encentradaSeleccionada.KAR_HORA = this.encentradaSeleccionada.KAR_HORA.toString().substr(0, 2) + '0'
        + this.encentradaSeleccionada.KAR_HORA.toString().substr(3, 1);
    }
    this.hora.setHours(this.encentradaSeleccionada.KAR_HORA.substr(0, 2));
    this.hora.setMinutes(this.encentradaSeleccionada.KAR_HORA.substr(3, 2));
    this.entradaService.encordprod = this.encentradaSeleccionada.ENCORDPRO_NUMERO;
    this.entradaService.encchkcentra = this.encentradaSeleccionada.ENCORDPRO_CHKCENTRA

    this.encentradaSeleccionada.KAR_COSTOTSA = isNullOrUndefined(this.encentradaSeleccionada.KAR_COSTOTSA) ? 0 : this.encentradaSeleccionada.KAR_COSTOTSA;
    this.encentradaSeleccionada.KAR_CANTIDADTSA = isNullOrUndefined(this.encentradaSeleccionada.KAR_CANTIDADTSA) ? 0 : this.encentradaSeleccionada.KAR_CANTIDADTSA;

    this.encentradaSeleccionada.KAR_COSTOTSA = Number(this.encentradaSeleccionada.KAR_COSTOTSA).toFixed(this.decimalesTotalEnt);
    this.encentradaSeleccionada.KAR_CANTIDADTSA = Number(this.encentradaSeleccionada.KAR_CANTIDADTSA).toFixed(this.decimalesCantidadEnt);
    this.encentradaSeleccionada.CENTRA_CODIGO=isNullOrUndefined(this.encentradaSeleccionada.CENTRA_CODIGO)?'':this.encentradaSeleccionada.CENTRA_CODIGO

    // this.entradaService.getEntradas(this.encentradaSeleccionada.KAR_NRO).subscribe((res1) => {
    this.entradaService.consultarDetKardex(this.encentradaSeleccionada.KAR_NRO).subscribe((res1) => {
      this.entradaService.detkardexarray[this.indicador] = res1 === null ? [] : res1;
      let hora;
      let minutos;
      hora = this.hora.getHours();
      minutos = this.hora.getMinutes();
      if (hora.toString().length === 1) {
        hora = '0' + hora;
      }
      if (minutos.toString().length === 1) {
        minutos = '0' + minutos;
      }
      const hour = hora + ':' + minutos;
      const date = this.datePipe.transform(this.date1, 'dd/MM/yyyy');
      let i = 0;
      this.entradaService.detkardexarray[this.indicador].map((entrada) => {
        i++;
        entrada.CEN_CODIGO = entrada.CEN_CODIGO === null || entrada.CEN_CODIGO === undefined ? '' : entrada.CEN_CODIGO //CDPJ
        entrada.DETKAR_COSTOUNIT = Number(entrada.DETKAR_COSTOUNIT).toFixed(this.decimalesPrecioEnt);
        entrada.DETKAR_COSTOTOTAL = Number(entrada.DETKAR_COSTOTOTAL).toFixed(this.decimalesTotalEnt);
        entrada.DETKAR_CANTIDAD = Number(entrada.DETKAR_CANTIDAD).toFixed(this.decimalesCantidadEnt);
        entrada.FECHA = date + '' + hour;
        entrada.HORA = hour;
        entrada.CLAVE = i + this.datePipe.transform(new Date(), 'dd/MM/yyyyHHmmss');
        entrada.DETKAR_PESO = isNullOrUndefined(entrada.DETKAR_PESO) ? 0 : entrada.DETKAR_PESO;
        entrada.DETKAR_PONDERADO = isNullOrUndefined(entrada.DETKAR_PONDERADO) ? 0 : entrada.DETKAR_PONDERADO;
        entrada.CENTRA_CODIGO = isNullOrUndefined(entrada.CENTRA_CODIGO) ? '' : entrada.CENTRA_CODIGO
        this.entradaSeleccionada = entrada;
      });
      this.aggrid.refreshaggrid(this.entradaService.detkardexarray[this.indicador], this.defaultColDefEntrada.objeto);
      this.entradaService.calcularTotal();
    });
  }
  nuevo() {

    if (this.permisoEntrada.PERINSERCION === 1) {
      this.nuevoEncEntrada();
    } else if (this.permisoEntrada.PERINSERCION === 0) {
      this.messageService.add({
        key: 'entprod',
        severity: 'error',
        summary: 'Insertar Entrada',
        detail: 'El usuario no tiene permisos de inserción, acción denegada'
      });
    }
  }

  eliminar() {
    if (this.permisoEntrada.PERELIMACION === 1) {
      this.confirmarBorrar();
    } else if (this.permisoEntrada.PERELIMACION === 0) {
      this.messageService.add({
        key: 'entprod',
        severity: 'error',
        summary: 'Eliminación Entrada',
        detail: 'El usuario no tiene permisos de eliminación, acción denegada'
      });
    }
  }

  async guardar() {
    //CDPJ
    let errores = 0;
    this.spin = true//CDPJ
    const ccpies = this.hmpConfiguracion.find(element => element.CFG_CODIGO === 'CCPIES').CFG_VALOR1;
    this.aggrid.init.grids[this.init.tabs[this.init.tabindex].indice + '_' + this.defaultColDefEntrada.objeto].setFocusedCell(this.entradaService.detkardexarray[this.indicador].length - 1, 'DETKAR_COSTOTOTAL');
    this.aggrid.refreshaggrid(this.entradaService.detkardexarray[this.indicador], this.defaultColDefEntrada.objeto);
    //CDPJ
    if (this.permisoEntrada.PERACTUALIZACION === 1) {
      if (this.entradaService.detkardexarray[this.indicador].length === 0) {
        this.messageService.add({
          key: 'entprod',
          severity: 'error',
          summary: 'Guardar Entrada',
          detail: 'El detalle de la entrada esta vació, no se pudo guardar la entrada'
        });
        this.control = 0;
        this.spin = false//CDPJ
      } else if (this.encentradaSeleccionada.KAR_NROCOMPROBANTE === '') {
        this.messageService.add({
          key: 'entprod',
          severity: 'error',
          summary: 'Guardar Entrada',
          detail: 'Ingrese el número de comprobante'
        });
        this.control = 0;
        this.spin = false//CDPJ
      } //else {
      //   this.guardarEntrada();
      // }
      else {
        if ((this.encentradaSeleccionada.ENCORDPRO_NUMERO === null || this.encentradaSeleccionada.ENCORDPRO_NUMERO === undefined ||
          this.encentradaSeleccionada.ENCORDPRO_NUMERO === '') && this.modulo === 'PROD') {
          this.messageService.add({
            key: 'entprod',
            severity: 'error',
            summary: 'Guardar Entrada',
            detail: 'Ingrese el número de la orden de producción.'
          });
          this.spin = false//CDPJ
          errores = errores + 1;
          this.control = 0;
          return;
        }
        //this.entradaService.detkardexarray[this.indicador].map((entrada) => {
        await Promise.all(this.entradaService.detkardexarray[this.indicador].map(async (entrada) => {
          //const rsdata: any = await this.entradaService.encontrarArtCntaySer(entrada.ART_CODIGO, 'A');
          let bod_codigo = 0
          const rsdata = await this.entradaService.erBodCodigo1(entrada.ART_CODIGO, 'A', entrada.BOD_CODIGO);
          let strCodigo = 0;
          if (rsdata !== null) {
            for (const rs of rsdata) {
              strCodigo = rs.NUMERO;
              bod_codigo = rs.BOD_CODIGO;
            }
          }
          if (ccpies === 1) {
            if (entrada.CEN_CODIGO === '') {
              this.messageService.add({
                key: 'entprod',
                severity: 'error',
                summary: 'Guardar Entrada',
                detail: 'Ingrese el centro de costos'
              });
              this.spin = false//CDPJ
              errores = errores + 1;
              this.control = 0;
            }

          }
          if (entrada.ART_CODIGO === '') {
            this.messageService.add({
              key: 'entprod',
              severity: 'error',
              summary: 'Guardar Entrada',
              detail: 'Ingrese el código del artículo'
            });
            this.spin = false//CDPJ
            errores = errores + 1;
            this.control = 0;
          }
          //CDPJ
          if (strCodigo === 0) {//CDPJ
            this.messageService.add({
              key: 'entprod',
              severity: 'error',
              summary: 'Información',
              detail: 'El artículo ' + entrada.ART_CODIGO + ' no existe'
            });
            this.spin = false//CDPJ
            errores++;
            this.control = 0;
          }
          if (entrada.BOD_CODIGO === null || entrada.BOD_CODIGO === '' || entrada.BOD_CODIGO === undefined) {
            this.messageService.add({
              key: 'entprod',
              severity: 'warn',
              summary: 'Información',
              detail: 'Error, Código de la bodega está vacío'
            });
            this.spin = false//CDPJ
            errores++;
            this.control = 0;
          }
          if (entrada.BOD_CODIGO !== null && entrada.BOD_CODIGO !== '' && entrada.BOD_CODIGO !== undefined) {
            if (bod_codigo === 0) {
              this.messageService.add({
                key: 'entprod',
                severity: 'warn',
                summary: 'Información',
                detail: 'Error, Código de la bodega ' + entrada.BOD_CODIGO + 'es incorrecto.'
              });
              this.spin = false//CDPJ
              errores++;
              this.control = 0;
            }
          }
          //CDPJ
        }));

        //CDPJ
        console.log('errores', errores)
        if (errores === 0) {
          this.guardarEntrada();
        }

      }
    } else if (this.permisoEntrada.PERACTUALIZACION === 0) {
      this.messageService.add({
        key: 'entprod',
        severity: 'error',
        summary: 'Actualización Entrada',
        detail: 'El usuario no tiene permisos de actualización, acción denegada'
      });
      this.spin = false//CDPJ
      this.control = 0;
    }
  }
  async guardarEntrada() {
    //CDPJ

    //GSRF
    if (this.modulo === 'PROD') {
      this.encentradaSeleccionada.KAR_ORIGEN = 'PROD';
    } else {
      if (this.checkSaldoI === true) {
        this.encentradaSeleccionada.KAR_ORIGEN = 'INV';
        this.encentradaSeleccionada.KAR_SALDOINI = 'S';
      } else if (this.checkSaldoI === false) {
        this.encentradaSeleccionada.KAR_ORIGEN = 'ES_INV';
      }

    }
    let hora;
    let minutos;
    hora = this.hora.getHours();
    minutos = this.hora.getMinutes();
    if (hora.toString().length === 1) {
      hora = '0' + hora;
    }
    if (minutos.toString().length === 1) {
      minutos = '0' + minutos;
    }
    this.encentradaSeleccionada.KAR_HORA = hora + ':' + minutos;
    this.encentradaSeleccionada.KAR_FECHA = this.datePipe.transform(this.date1, 'dd/MM/yyyy');
    console.log(this.encentradaSeleccionada.KAR_NRO)
    if (this.encentradaSeleccionada.KAR_NRO !== '' && this.encentradaSeleccionada.KAR_NRO !== undefined && this.encentradaSeleccionada.KAR_NRO !== null) {
      this.entradaService.actualizarEncEntrada(this.encentradaSeleccionada).subscribe(async () => {

        this.auditoriagral.registrarAuditoria('INV_ENCKARDEX', String(this.encentradaSeleccionada.KAR_NRO), 'A',
          '', '01', '', '', '', '').subscribe(() => {
          });
        //CDPJ
        if (this.entradaService.detkardexarray[this.indicador].length !== 0) {
          // console.log(this.entradaSeleccionada);
          for (const entrada of this.entradaService.detkardexarray[this.indicador]) {
            //this.entradaService.detkardexarray[this.indicador].map((entrada) => {
            entrada.KAR_NRO = this.encentradaSeleccionada.KAR_NRO;
            //entrada.DETKAR_NRODOC = '';
            entrada.CON_CODIGO = '';
            entrada.ENCGRE_CODIGO = '';
            entrada.DETGRE_LINEA = '';
            entrada.DETKAR_LOTE = '';
            entrada.CLI_CODIGO = '';
            entrada.MAEPUN_CODIGO = '';
            entrada.DETKAR_CODIGOAUX = '';
            entrada.DETKAR_CAJAS = '';
            entrada.DETKAR_FRACCIONES = '';
            entrada.DETKAR_CANTIDADUND = 0;
            entrada.DETKAR_PESO = Number(entrada.DETKAR_PESO)
            entrada.CENTRA_CODIGO=isNullOrUndefined( this.encentradaSeleccionada.CENTRA_CODIGO)?'':this.encentradaSeleccionada.CENTRA_CODIGO
            try {
              const res1 = await this.entradaService.insertarEntrada(entrada).toPromise()
              //this.entradaService.insertarEntrada(entrada).subscribe((res1) => {
              //const detKarLinea = JSON.stringify(res1[0]);
              //this.obtenerDetKarLinea(detKarLinea, entrada);
              if (entrada.DETKAR_LINEA === 0) {
                this.auditoriagral.registrarAuditoria('INV_DETKARDEX', String(entrada.KAR_NRO) + '/' + entrada.ART_CODIGO + '/cant/' + entrada.DETKAR_CANTIDAD + '/cosuni/' + entrada.DETKAR_COSTOUNIT + '/costotal/' + entrada.DETKAR_COSTOTOTAL
                  + '/CenTrab:' + entrada.CENTRA_CODIGO, 'I',
                  '', '01', '', '', '', '').subscribe(() => {
                  });
              } else if (entrada.DETKAR_LINEA > 0) {
                this.auditoriagral.registrarAuditoria('INV_DETKARDEX', String(entrada.KAR_NRO) + '/' + entrada.ART_CODIGO + '/cant/' + entrada.DETKAR_CANTIDAD + '/cosuni/' + entrada.DETKAR_COSTOUNIT + '/costotal/' + entrada.DETKAR_COSTOTOTAL
                  + '/CenTrab:' + entrada.CENTRA_CODIGO, 'A',
                  '', '01', '', '', '', '').subscribe(() => {
                  });
              }
              for (const rs of res1) {
                //  console.log(rs)
                //  console.log(rs[':B1'])
                entrada.DETKAR_LINEA = rs[':B1']
              }

              //subscribe(() => {
              //});
            } catch (error) {
              this.messageService.add({
                key: 'entprod',
                severity: 'error',
                summary: 'Actualización de Entrada',
                detail: 'No se puede insertar el detalle'
              });
              this.control = 0;
              this.spin = false//CDPJ
            }
          }
          this.spin = false//CDPJ
          this.control = 0;
          if (this.modulo === 'PROD') {
            await this.generarAsientoPod()
          }
        } else {
          return;
        }
        await this.entradaService.actualizarKardex_en_sa(this.encentradaSeleccionada).toPromise()

        this.messageService.add({
          key: 'entprod',
          severity: 'success',
          summary: 'Actualización de Entrada',
          detail: 'Se actualizó la entrada correctamente'
        });
        this.spin = false//CDPJ
        this.control = 0;
        //CDPJ
        this.botonesguardar();
        const res = await this.entradaService.getEncEntradas().toPromise()//subscribe((res) => {
        this.encEntradas = res;
        this.indice = this.encEntradas.length - 1
        //});
        await this.manejarSenales('Cancelar');
        //CDPJ
      }, error1 => {
        let mensaje: string;
        mensaje = this.errorService.generarMensajeError(error1.error.substr(0, 9));
        this.messageService.add({
          key: 'entprod',
          severity: 'error',
          summary: 'Actualización de Entrada',
          detail: mensaje
        });
        this.spin = false//CDPJ
        this.control = 0;
      });

    } else {
      this.entradaService.insertarEncEntrada(this.encentradaSeleccionada).subscribe(async (res) => {
        this.encentradaSeleccionada.KAR_NRO = JSON.stringify(res[0]).substr(8, 12);

        this.auditoriagral.registrarAuditoria('INV_ENCKARDEX', String(this.encentradaSeleccionada.KAR_NRO), 'I',
          '', '01', '', '', '', '').subscribe(() => {
          });
        if (this.entradaService.detkardexarray[this.indicador].length !== 0) {
          // console.log(this.entradaSeleccionada);
          for (const entrada of this.entradaService.detkardexarray[this.indicador]) {
            try {
              // this.entradaService.detkardexarray[this.indicador].map((entrada) => {
              entrada.KAR_NRO = this.encentradaSeleccionada.KAR_NRO;
              // entrada.DETKAR_COSTOTOTAL = (Number(entrada.DETKAR_COSTOUNIT) *
              //   Number(entrada.DETKAR_CANTIDAD)) + '';
              entrada.DETKAR_PESO = Number(entrada.DETKAR_PESO)
              entrada.CENTRA_CODIGO=isNullOrUndefined( this.encentradaSeleccionada.CENTRA_CODIGO)?'':this.encentradaSeleccionada.CENTRA_CODIGO
              const res1 = await this.entradaService.insertarEntrada(entrada).toPromise()
              console.log(entrada);
              console.log(res1);
              //this.entradaService.insertarEntrada(entrada).subscribe((res1) => {
              //const detKarLinea = JSON.stringify(res1[0]);
              //this.obtenerDetKarLinea(detKarLinea, entrada);
              for (const rs of res1) {
                console.log(rs)
                console.log(rs[':B1'])
                entrada.DETKAR_LINEA = rs[':B1']
              }
              //const detKarLinea = JSON.stringify(res1[0]);
              //this.obtenerDetKarLinea(detKarLinea, entrada);

              if (entrada.DETKAR_LINEA === 0) {
                this.auditoriagral.registrarAuditoria('INV_DETKARDEX', String(entrada.KAR_NRO) + '/' + entrada.ART_CODIGO + '/cant/' + entrada.DETKAR_CANTIDAD + '/cosuni/' + entrada.DETKAR_COSTOUNIT + '/costotal/' + entrada.DETKAR_COSTOTOTAL
                  + '/CenTrab:' + entrada.CENTRA_CODIGO, 'I',
                  '', '01', '', '', '', '').subscribe(() => {
                  });
              } else if (entrada.DETKAR_LINEA > 0) {
                this.auditoriagral.registrarAuditoria('INV_DETKARDEX', String(entrada.KAR_NRO) + '/' + entrada.ART_CODIGO + '/cant/' + entrada.DETKAR_CANTIDAD + '/cosuni/' + entrada.DETKAR_COSTOUNIT + '/costotal/' + entrada.DETKAR_COSTOTOTAL
                  + '/CenTrab:' + entrada.CENTRA_CODIGO, 'A',
                  '', '01', '', '', '', '').subscribe(() => {
                  });
              }
              //subscribe(() => {
              //});
              // }, error1 => {
              //   this.messageService.add({
              //     key: 'entprod',
              //     severity: 'error',
              //     summary: 'Actualización de Entrada',
              //     detail: 'No se puede insertar el detalle'
              //   });
              //   this.spin=false
            } catch (error) {
              this.messageService.add({
                key: 'entprod',
                severity: 'error',
                summary: 'Actualización de Entrada',
                detail: 'No se puede insertar el detalle'
              });
              this.control = 0;
              this.spin = false
            }
            // });
          }//);
          if (this.modulo === 'PROD') {
            await this.generarAsientoPod()
          }
        } else {
          this.spin = false//CDPJ
          return;
        }

        //CDPJ
        this.messageService.add({
          key: 'entprod',
          severity: 'success',
          summary: 'Inserción de Entrada',
          detail: 'Se ingresó la entrada correctamente'
        });
        this.spin = false//CDPJ
        this.control = 0;
        await this.entradaService.actualizarKardex_en_sa(this.encentradaSeleccionada).toPromise()
        const res1 = await this.entradaService.getEncEntradas().toPromise()//subscribe((res) => {
        this.encEntradas = res1;
        this.indice = this.encEntradas.length - 1
        //});
        await this.manejarSenales('Cancelar');
        //CDPJ
        this.botonesguardar();
      }, error1 => {
        let mensaje: string;
        mensaje = this.errorService.generarMensajeError(error1.error.substr(0, 9));
        this.messageService.add({
          key: 'entprod',
          severity: 'error',
          summary: 'Inserción de Entrada',
          detail: mensaje
        });
        this.spin = false//CDPJ
      });

    }



  }
  buscar() {

    this.opcion = 'BUSQUEDA';
    this.types = [
      { label: 'Número', value: 'KAR_NRO' },
      { label: 'Fecha', value: 'KAR_FECHA' },
      { label: 'Comentario', value: 'KAR_COMENTARIO' },
      { label: 'Comprobante', value: 'KAR_NROCOMPROBANTE' },
      { label: 'No. Asiento', value: 'ASI_NRO' },
      { label: 'ORDEN PROD', value: 'ENCORDPRO_NUMERO' },
      { label: 'Origen', value: 'KAR_ORIGEN' },
    ];
    this.busquedacampos = ['', '', '', '', '', '', ''];
    this.tabla = 'INV_ENCKARDEX';
    if (this.modulo === 'PROD') {
      this.where = 'KAR_TIPO = \'EN\' AND KAR_ORIGEN = \'PROD\' AND ROWNUM < 50 ORDER BY KAR_NRO DESC';
    } else {
      this.where = 'KAR_TIPO = \'EN\' AND (KAR_ORIGEN = \'ES_INV\' OR KAR_ORIGEN = \'INV\') AND ROWNUM < 50 ORDER BY KAR_NRO DESC';
    }
    this.busquedaSer.busquedaInvEncKardex1NEW(this.modulo).subscribe((res: any[]) => {
      this.arregloCons = res;
      this.arregloCons.map((registro) => {
        registro.KAR_FECHA = this.datePipe.transform(registro.KAR_FECHA, 'dd/MM/yyyy');
      });
      this.inputsBoolean = false;//GSRF 
      this.displayDialogBusquedaFast = true;
    });
  }
  nuevoEncEntrada() {
    this.botonNuevo = true;
    this.botonGuardar = false;
    this.botonBorrar = true;
    this.botonRegresar = false;
    this.inputsBoolean = false;
    let encEntrada: Invencentrada;
    encEntrada = {
      KAR_NRO: '', KAR_TIPO: 'EN', COM_CODIGO: '01', TIPDIA_CODIGO: 'EN', USUIDENTIFICACION: this.usuario.identificacion, KAR_NO_KARDEX: '0',
      KAR_SALDOINI: '', KAR_ESTADO: '', ENCORDPRO_NUMERO: '', KAR_COMENTARIO: '',CENTRA_CODIGO:'',
    };
    this.date1 = new Date();
    this.hora = new Date();
    // this.encEntradas.push(encEntrada);
    this.encentradaSeleccionada = encEntrada;
    this.entradaService.detkardexarray[this.indicador] = [];
    this.entradaService.encordprod = ''
    this.entradaService.encchkcentra = 0
    this.activeIndex = 0;
    document.getElementById('nroCompra').focus();
    this.checkSaldoI = false;
  }
  confirmarBorrar() {
    this.confirmationService.confirm({
      message: 'Esta seguro que desea eliminar la entrada',
      header: 'Eliminar Entrada',
      icon: 'pi pi-exclamation-triangle',
      key: 'confirmarEntprod',
      accept: () => {
        if (this.permisoEntrada.PERELIMACION === 1) {
          this.borrarEncEntrada();
        } else if (this.permisoEntrada.PERELIMACION === 0) {
          this.messageService.add({
            key: 'entprod',
            severity: 'error',
            summary: 'Eliminación Entrada',
            detail: 'El usuario no tiene permisos de eliminación, acción denegada'
          });
        }

      },
      reject: () => {
      }
    });
  }

  async borrarEncEntrada() {
    //validar que la entrada no esté en una orden de producción ya ingresada
    let prodin = 0;
    let pondera = 0
    if (this.modulo === 'PROD') {
      const rs = await this.entradaService.ValidaEnSaOrdProd(this.encentradaSeleccionada);
      const rs1 = await this.entradaService.ValidaPonderacion(this.encentradaSeleccionada);
      //console.log('rs',rs)
      if (rs !== null && rs !== undefined) {
        for (const data of rs) {
          prodin = data.NUMERO
        }
      }
      if (rs1 !== null && rs1 !== undefined) {
        for (const data of rs1) {
          pondera = data.NUMERO
        }
      }
    }
    if (this.modulo === 'PROD' && prodin > 0) {
      this.messageService.add({
        key: 'entprod',
        severity: 'error',
        summary: 'Eliminación de Entrada',
        detail: 'No se puede editar la entrada ya que la Orden de Producción está ingresada'
      });
      this.control = 0
      return;
    }
    if (pondera > 0) {
      this.messageService.add({
        key: 'entprod',
        severity: 'error',
        summary: 'Eliminación de Entrada',
        detail: 'No se puede editar la entrada ya que se encuentra ponderada '
      });
      this.control = 0
      return;
    }

    try {
      await this.entradaService.borrarEncEntrada(this.encentradaSeleccionada).toPromise()//.subscribe(() => {
      let numero = '';
      if (this.encentradaSeleccionada.ASI_NRO !== undefined || this.encentradaSeleccionada.ASI_NRO !== '') {
        numero = this.encentradaSeleccionada.ASI_NRO;
        if (numero !== undefined || numero !== '') {
          await this.entradaService.eliminarAsientoCont(numero).toPromise()//.subscribe(() => {
          //});
        }
      }
      this.encEntradas.splice(this.encEntradas.findIndex(
        entrada => entrada.KAR_NRO === this.encentradaSeleccionada.KAR_NRO),
        1);

      this.entradaService.detkardexarray[this.indicador] = [];
      this.aggrid.refreshaggrid(this.entradaService.detkardexarray[this.indicador], this.defaultColDefEntrada.objeto);
      let karnro = this.encentradaSeleccionada.KAR_NRO
      this.encentradaSeleccionada = {};
      this.date1 = new Date();
      this.hora = new Date();

      this.messageService.add({
        key: 'entprod',
        severity: 'success',
        summary: 'Eliminicación de Entrada',
        detail: 'Se eliminó la entrada correctamente'
      });
      this.entradaService.calcularTotal();
      this.auditoriagral.registrarAuditoria('INV_ENCKARDEX', String(karnro), 'E',
        '', '01', '', '', '', '').subscribe(() => {
        });
      // }, error1 => {
      //   let mensaje: string;
      //   mensaje = this.errorService.generarMensajeError(error1.error.substr(0, 9));
      //   this.messageService.add({
      //     key: 'entprod',
      //     severity: 'error',
      //     summary: 'Eliminicación de Entrada',
      //     detail: mensaje
      //   });
      // });
    } catch (error1) {
      let mensaje: string;
      mensaje = this.errorService.generarMensajeError(error1.error.substr(0, 9));
      this.messageService.add({
        key: 'entprod',
        severity: 'error',
        summary: 'Eliminicación de Entrada',
        detail: mensaje
      });
    }


  }
  async generarAsientoPod() {

    try {
      if (this.checkSaldoI === false) {//CDPJ
        await this.entradaService.generarAsientoProdProm(this.encentradaSeleccionada);
        const resp = await this.entradaService.getAsientoProm(this.encentradaSeleccionada);
        await this.auditoriagral.registrarAuditoria('CON_ENCASI_L', '/Numero:' + this.encentradaSeleccionada.KAR_NRO + '/AsiNumero:' + resp[0].ASI_NRO + '/INV-PROD'
          , 'A',
          this.usuario.identificacion, '01', '', '', '', '').toPromise()

        console.log(resp);
        this.encentradaSeleccionada.ASI_NRO = resp[0].ASI_NRO;
        console.log('asiento numero', this.encentradaSeleccionada.ASI_NRO)
        this.messageService.add({
          key: 'entprod',
          severity: 'success',
          summary: 'Asiento Contable',
          detail: 'Se generó el asiento contable'
        });
        this.spin = false//CDPJ
      } else {
        this.messageService.add({
          key: 'entprod',
          severity: 'warn',
          summary: 'Asiento Contable',
          detail: 'La entrada tiene saldo inicial'
        });
        this.spin = false//CDPJ
      }

    } catch (err) {
      this.messageService.add({
        key: 'entprod',
        severity: 'error',
        summary: 'Asiento Contable',
        detail: 'No se generó el asiento contable'
      });
    }


  }
  abrirLotes(params) {
    this.entradaSeleccionada = params;
    this.auxiliarlot++;
    this.displayDialogLotes = this.encentradaSeleccionada.KAR_NRO.length > 0 && this.entradaSeleccionada.ART_CADUCA === 'S';
  }

  cerrarLotes() {
    this.displayDialogLotes = false;
  }
  cerrasdistribucion() {
    this.displaydistribucion = false
  }
  async insertardatosordpro() {
    try {
      this.displayAcciones = false;
      const elemento = document.getElementsByClassName('layout-config');
      for (let i = 0; i < elemento.length; i++) {
        elemento[i].className = 'layout-config';
      }

      const dato = await this.entradaService.insertardatosordpro(this.encentradaSeleccionada.ENCORDPRO_NUMERO)

      let v_cantidad_por_ent = 0
      let v_cantidad_entro = 0
      let coindicendias = 0;
      let costoprom = 0
      let nombreart = ''
      let bodcod = ''
      if (isNullOrUndefined(dato) === false) {
        for (const iterator of dato) {
          nombreart = isNullOrUndefined(iterator.ART_NOMBRE) ? '' : iterator.ART_NOMBRE
          bodcod = isNullOrUndefined(iterator.BOD_CODIGO) ? '' : iterator.BOD_CODIGO
          for (const rs of this.entradaService.detkardexarray[this.indicador]) {
            if (rs.ART_CODIGO === iterator.ART_CODIGO) {
              coindicendias++;
            }
          }
          if (coindicendias === 0) {
            let numero;
            if (this.encentradaSeleccionada.KAR_NRO !== undefined || this.encentradaSeleccionada.KAR_NRO !== '') {
              numero = this.encentradaSeleccionada.KAR_NRO;
            } else if (this.encentradaSeleccionada.KAR_NRO === undefined || this.encentradaSeleccionada.KAR_NRO === '') {
              numero = '';
            }

            let hora;
            let minutos;
            hora = this.hora.getHours();
            minutos = this.hora.getMinutes();
            if (hora.toString().length === 1) {
              hora = '0' + hora;
            }
            if (minutos.toString().length === 1) {
              minutos = '0' + minutos;
            }
            const hour = hora + ':' + minutos;
            const date = this.datePipe.transform(this.date1, 'dd/MM/yyyy');
            //Verifica si ya esta incluido en otra Entrada
            const data1 = await this.entradaService.getartendatosordpro(this.encentradaSeleccionada.ENCORDPRO_NUMERO, iterator.ART_CODIGO, date, hour)
            if (isNullOrUndefined(data1) === false) {
              for (const rs1 of data1) {
                v_cantidad_entro = Number(rs1.CANTIDAD)
                costoprom = Number(rs1.COSTOPROM)
              }
            }
            v_cantidad_por_ent = Number(iterator.ENCORDPRO_CANTIDAD) - Number(v_cantidad_entro)
            let i = this.entradaService.detkardexarray[this.indicador].length + 1;//CDPJ
            const nuevaentrada = {
              CLAVE: i + this.datePipe.transform(new Date(), 'dd/MM/yyyyHHmmss'),//CDPJ
              DETKAR_CANTIDAD: v_cantidad_por_ent, DETKAR_COSTOUNIT: costoprom, DETKAR_COSTOTOTAL: 1.00,
              DETKAR_LINEA: 0, KAR_NRO: numero, DETKAR_NRODOC: '', ENCGRE_CODIGO: '',
              DETGRE_LINEA: '0', DETKAR_LOTE: '', CLI_CODIGO: '', DETKAR_PUNTOS: '0', MAEPUN_CODIGO: '', DETKAR_CODIGOAUX: '',
              DETKAR_CAJAS: '', DETKAR_FRACCIONES: '', CON_CODIGO: '', BOD_CODIGO: bodcod, ART_CODIGO: iterator.ART_CODIGO, ART_NOMBRE: nombreart, COM_CODIGO: '01',
              DETKAR_CANTIDADUND: 0, FECHA: date + '' + hour, HORA: hour, CEN_CODIGO: '', DETKAR_PESO: Number(0).toFixed(2), DETKAR_PONDERADO: Number(0).toFixed(2),
              CENTRA_CODIGO:''
            };

            this.entradaService.detkardexarray[this.indicador].push(nuevaentrada);
            this.entradaService.calcularTotal()
            this.aggrid.refreshaggrid(this.entradaService.detkardexarray[this.indicador], this.defaultColDefEntrada.objeto);

          }


        }
      }
    } catch (error) {
      this.messageService.add({
        key: 'ent',
        severity: 'warn',
        summary: 'Información',
        detail: 'Ocurrio un error al ejecutar el proceso.' + error
      });
      return false;
    }
  }

  cerrarReportes() {
    this.displayDialogReportes = false;
  }

  recibirSenalesDocumentos(valor) {
    if (valor === true) {
      this.displayDialogDocumentos = false;
    }
  }
  acciones(valor) {
    this.displayAcciones = !this.displayAcciones;
    const elemento = document.getElementsByClassName('layout-config');
    if (this.displayAcciones === true) {
      for (let i = 0; i < elemento.length; i++) {
        elemento[i].className += ' layout-config-active';
      }
    } else if (this.displayAcciones === false) {
      for (let i = 0; i < elemento.length; i++) {
        elemento[i].className = 'layout-config';
      }
    }

  }
  busqueCenTrab(opcion) {
    this.opcion = 'CENTROTRAB';
    this.types = [
      { label: 'Código', value: 'CENTRA_CODIGO' },
      { label: 'Descripción', value: 'TRNCENTRA_DESCRIPCION' }
    ];
    let parametro = isNullOrUndefined(opcion) ? '' : opcion;
    let ordprod = ''
    ordprod = this.entradaService.encordprod;

    this.busquedacampos = [parametro, ''];
    //this.consulta = '*';
    this.tabla = 'PROD_TRNCENTRA';
    this.where = 'ENCORDPRO_NUMERO=\'' + ordprod + '\' order by CENTRA_CODIGO asc';


    this.busquedaSer.busquedaCentrabinvprod(parametro,ordprod).subscribe((eR: any[]) => {
      if (eR !== null) {
        if (Object.keys(eR).length === 1) {
          this.manejarSeleccion(eR[0]);
        } else {
          this.busquedaSer.busquedaCentrabinvprodparams(parametro,ordprod).subscribe((res: any[]) => {
            if (res !== null && Object.keys(res).length > 0) {

              this.arregloCons = res;
              this.displayDialogBusquedaFast = true;
            }
          });
        }
      } else {
        this.busquedaSer.busquedaCentrabinvprodparams(parametro,ordprod).subscribe((res: any[]) => {
          if (res !== null && Object.keys(res).length > 0) {

            this.arregloCons = res;
            this.displayDialogBusquedaFast = true;
          }
        });
      }
    });
  }
  manejarSeleccion(opcion) {
    //GSRF
    if (this.opcion === 'orden') {
      this.encentradaSeleccionada.ENCORDPRO_NUMERO = opcion.ENCORDPRO_NUMERO;
      this.entradaService.encordprod = opcion.ENCORDPRO_NUMERO;
      this.entradaService.encchkcentra = opcion.ENCORDPRO_CHKCENTRA;

      this.displayDialogBusqueda = false;
      this.displayDialogBusquedaFast = false;
    }

    //GSRF
    if (this.opcion === 'BUSQUEDA') {
      this.encEntradas.map((enca) => {
        if (enca.KAR_NRO === opcion.KAR_NRO) {
          this.indice = this.encEntradas.indexOf(enca);
        }
      });
      if (this.indice === this.encEntradas.length - 1) {
        this.botonUltimo = true;
        this.botonSiguiente = true;
        this.encentradaSeleccionada = this.encEntradas[this.indice];
        this.obtenerDatos();
      } else if (this.indice === 0) {
        this.botonPrimero = true;
        this.botonAnterior = true;
        this.encentradaSeleccionada = this.encEntradas[this.indice];
        this.obtenerDatos();
      } else {
        this.botonPrimero = false;
        this.botonAnterior = false;
        this.botonSiguiente = false;
        this.botonUltimo = false;
        this.encentradaSeleccionada = this.encEntradas[this.indice];
        this.obtenerDatos();
      }
      
      this.displayDialogBusqueda = false;
      this.displayDialogBusquedaFast = false;
    }
    if (this.opcion === 'CENTROTRAB') {
      this.encentradaSeleccionada.CENTRA_CODIGO = opcion.CENTRA_CODIGO;
      this.encentradaSeleccionada.CENTRA_DESCRIPCION = opcion.TRNCENTRA_DESCRIPCION;
      this.displayDialogBusqueda = false;
      this.displayDialogBusquedaFast = false;
    }
  }
  cambio(valor) {
    this.botonGuardar = false;
    this.botonRegresar = false;
    this.botonNuevo = true;
    this.botonBorrar = false;
    this.btnNuevoGrid = false;
    this.botonUltimo = true;
    this.botonAnterior = true;
    this.botonSiguiente = true;
    this.botonPrimero = true;
  }
  cambiarFoco(evento) {
    if (evento.target.id === 'nroCompra') {
      document.getElementById('comentario').focus();
    } else if (evento.target.id === 'comentario') {
      this.nuevoDetEntrad();
    }
  }
  seleccionEntrada(params) {
    if (params === 'nuevo') {
      this.nuevoDetEntrad();
    } else if (params === 'eliminar') {
      this.enviarBorrarEntrada();
    } else if (params === 'cancelar') {
      // this.enviarCancelarEntrada();
    } else if (params === 'btnDistribESP') {
      if (isNullOrUndefined(this.encentradaSeleccionada.KAR_NRO) || this.encentradaSeleccionada.KAR_NRO === '') {
        this.messageService.add({
          key: 'entprod',
          severity: 'error',
          summary: 'Eliminación de Entrada',
          detail: 'Debe guardar primero la entrada'
        });
        return;

      }
      if (isNullOrUndefined(this.encentradaSeleccionada.ENCORDPRO_NUMERO) || this.encentradaSeleccionada.ENCORDPRO_NUMERO === '') {
        this.messageService.add({
          key: 'entprod',
          severity: 'error',
          summary: 'Eliminación de Entrada',
          detail: 'Debe seleccionar una orden de producción'
        });
        return;

      }
      this.displaydistribucion = true

    } else if (params.object !== undefined) {
      this.entradaSeleccionada = params.object;
      if (this.encentradaSeleccionada.KAR_NRO !== undefined || this.encentradaSeleccionada.KAR_NRO !== '') {
        this.entradaSeleccionada.KAR_NRO = this.encentradaSeleccionada.KAR_NRO;
      }
    }
  }

  nuevoDetEntrad() {
    this.btnNuevoGrid = true;
    this.btnGuardarGrid = false;
    this.btnBorrarGrid = false;
    this.btnCancelarGrid = false;
    let numero;
    if (this.encentradaSeleccionada.KAR_NRO !== undefined || this.encentradaSeleccionada.KAR_NRO !== '') {
      numero = this.encentradaSeleccionada.KAR_NRO;
    } else if (this.encentradaSeleccionada.KAR_NRO === undefined || this.encentradaSeleccionada.KAR_NRO === '') {
      numero = '';
    }

    let hora;
    let minutos;
    hora = this.hora.getHours();
    minutos = this.hora.getMinutes();
    if (hora.toString().length === 1) {
      hora = '0' + hora;
    }
    if (minutos.toString().length === 1) {
      minutos = '0' + minutos;
    }
    const hour = hora + ':' + minutos;
    const date = this.datePipe.transform(this.date1, 'dd/MM/yyyy');
    let i = this.entradaService.detkardexarray[this.indicador].length + 1;//CDPJ
    const nuevaentrada = {
      CLAVE: i + this.datePipe.transform(new Date(), 'dd/MM/yyyyHHmmss'),//CDPJ
      DETKAR_CANTIDAD: 1.00, DETKAR_COSTOUNIT: 1.00, DETKAR_COSTOTOTAL: 1.00,
      DETKAR_LINEA: 0, KAR_NRO: numero, DETKAR_NRODOC: '', ENCGRE_CODIGO: '',
      DETGRE_LINEA: '0', DETKAR_LOTE: '', CLI_CODIGO: '', DETKAR_PUNTOS: '0', MAEPUN_CODIGO: '', DETKAR_CODIGOAUX: '',
      DETKAR_CAJAS: '', DETKAR_FRACCIONES: '', CON_CODIGO: '', BOD_CODIGO: '', ART_CODIGO: '', ART_NOMBRE: '', COM_CODIGO: '01',
      DETKAR_CANTIDADUND: 0, FECHA: date + '' + hour, HORA: hour, CEN_CODIGO: '', DETKAR_PESO: Number(0).toFixed(this.entradaService.decimalespeso), DETKAR_PONDERADO: Number(0).toFixed(2),
      CENTRA_CODIGO: ''
    };
    this.entradaSeleccionada = nuevaentrada;
    this.entradaService.detkardexarray[this.indicador].push(nuevaentrada);
    this.aggrid.refreshaggrid(this.entradaService.detkardexarray[this.indicador], this.defaultColDefEntrada.objeto);
  }
  async enviarBorrarEntrada() {
    if (this.entradaSeleccionada.DETKAR_LINEA === 0) {
      this.btnNuevoGrid = false;
      this.btnGuardarGrid = false;
      this.btnBorrarGrid = false;
      this.btnCancelarGrid = false;

      this.messageService.add({
        key: 'entprod',
        severity: 'success',
        summary: 'Eliminación de Entrada',
        detail: 'La entrada se eliminó correctamente'
      });
      this.entradaService.detkardexarray[this.indicador] = this.entradaService.detkardexarray[this.indicador].filter
        ((val, j) => j !== this.entradaService.detkardexarray[this.indicador].indexOf
          (this.entradaService.detkardexarray[this.indicador][this.entradaService.detkardexarray[this.indicador].length - 1]));
      //CDPJ
      this.entradaService.calcularTotal();
      this.btnNuevoGrid = false;
      return;
    } else {
      let prodin = 0;
      let pondera = 0
      if (this.modulo === 'PROD') {
        const rs = await this.entradaService.ValidaEnSaOrdProd(this.encentradaSeleccionada);
        const rs1 = await this.entradaService.ValidaPonderacion(this.encentradaSeleccionada);
        //console.log('rs',rs)
        if (rs !== null && rs !== undefined) {
          for (const data of rs) {
            prodin = data.NUMERO
          }
        }
        if (rs1 !== null && rs1 !== undefined) {
          for (const data of rs1) {
            pondera = data.NUMERO
          }
        }
      }
      if (this.modulo === 'PROD' && prodin > 0) {
        this.messageService.add({
          key: 'entprod',
          severity: 'error',
          summary: 'Eliminación de Entrada',
          detail: 'No se puede editar la entrada ya que la Orden de Producción está ingresada'
        });
        this.control = 0
        return;
      }
      if (pondera > 0) {
        this.messageService.add({
          key: 'entprod',
          severity: 'error',
          summary: 'Eliminación de Entrada',
          detail: 'No se puede editar la entrada ya que se encuentra ponderada '
        });
        this.control = 0
        return;
      }
      let contador = 0;
      let i = 0;
      do {
        if (this.entradaSeleccionada === this.entradaService.detkardexarray[this.indicador][i]) {
          contador++;
        }
        i++;
      } while (this.entradaService.detkardexarray[this.indicador].length > i);
      if (contador === 1) {
        this.entradaService.borrarEntrada(this.entradaSeleccionada).subscribe(() => {
          this.messageService.add({
            key: 'entprod',
            severity: 'success',
            summary: 'Eliminación de Entrada',
            detail: 'La entrada se eliminó correctamente'
          });
          this.entradaService.detkardexarray[this.indicador] = this.entradaService.detkardexarray[this.indicador].filter((val, j) =>
            j !== this.entradaService.detkardexarray[this.indicador].indexOf(this.entradaSeleccionada));
          //CDPJ
          this.auditoriagral.registrarAuditoria('INV_DETKARDEX', String(this.entradaSeleccionada.KAR_NRO) + '/' + this.entradaSeleccionada.ART_CODIGO + '/cant/' + this.entradaSeleccionada.DETKAR_CANTIDAD +
            '/costo/' + this.entradaSeleccionada.DETKAR_COSTOTOTAL + '/CenTrab:' + this.entradaSeleccionada.CENTRA_CODIGO, 'E',
            '', '01', '', '', '', '').subscribe(() => {
            });
          this.entradaService.calcularTotal();
          this.btnNuevoGrid = false;

        }, error1 => {
          let mensaje: string;
          mensaje = this.errorService.generarMensajeError(error1.error.substr(0, 9));
          this.messageService.add({
            key: 'entprod',
            severity: 'error',
            summary: 'Eliminación de Entrada',
            detail: mensaje
          });
        });
      } else if (contador !== 1) {
        this.entradaService.detkardexarray[this.indicador] = this.entradaService.detkardexarray[this.indicador].filter((val, j) =>
          j !== this.entradaService.detkardexarray[this.indicador].indexOf(this.entradaSeleccionada));
      }
    }

  }
  busquedaorden() {
    this.opcion = 'orden';
    this.types = [
      { label: 'Orden', value: 'ENCORDPRO_NUMERO' },
      { label: 'Referencia', value: 'ENCORDPRO_REFERENCIA' },
      { label: 'Fecha Emi.', value: 'ENCORDPRO_FECHAEMISION' },
      { label: 'Fecha Inicio', value: 'ENCORDPRO_FECHAINICIO' },
      { label: 'Estado', value: 'ENCORDPRO_ESTADO' }
    ];
    this.busquedacampos = ['', '', '', '', ''];
    //this.consulta = '*';
    this.tabla = 'PROD_ENCORDPRO';
    this.where = ' ENCORDPRO_ESTADO=\'P\' AND ENCORDPRO_TIPOPROD=\'P\' ';

    this.busquedaSer.busquedaNEW().subscribe((datos: any[]) => {
      this.arregloCons = datos;
      this.arregloCons.map((registro) => {
        if (registro.ENCORDPRO_FECHAEMISION !== null) {
          registro.ENCORDPRO_FECHAEMISION = this.datePipe.transform(registro.ENCORDPRO_FECHAEMISION, 'dd/MM/yyyy');
        } else {
          registro.ENCORDPRO_FECHAEMISION = '';
        }
        if (registro.ENCORDPRO_FECHAINICIO !== null) {
          registro.ENCORDPRO_FECHAINICIO = this.datePipe.transform(registro.ENCORDPRO_FECHAINICIO, 'dd/MM/yyyy');
        } else {
          registro.ENCORDPRO_FECHAINICIO = '';
        }
      });
      this.displayDialogBusquedaFast = true;
    });
  }
  recibirSenalesConEncasil(valor) {
    if (valor === true) {
      this.displayAsiContable = false;
    }
  }
  reversarponderacion() {
    this.displayAcciones = false;
    const elemento = document.getElementsByClassName('layout-config');
    for (let i = 0; i < elemento.length; i++) {
      elemento[i].className = 'layout-config';
    }
    this.confirmationService.confirm({
      message: 'Está seguro de reversar la ponderación?',
      header: 'Información',
      icon: 'pi pi-question',
      key: 'confirmarEntprod',
      accept: async () => {
        try {
          await this.entradaService.reversarponderacion(this.entradaSeleccionada.KAR_NRO);
          await this.auditoriagral.registrarAuditoria('INV_ENCKARDEX', 'EJECUTAR-REVERSAR-PONDERACIÓN' + '/KarNro:' + this.encentradaSeleccionada.KAR_NRO, 'A',
            '', '01', '', '', '', '').toPromise()
          await this.manejarSenales('Cancelar');
          this.messageService.add({
            key: 'ent',
            severity: 'success',
            summary: 'Eliminación de Entrada',
            detail: 'Ponderación reversada correctamente'
          });
        } catch (error) {
          this.messageService.add({
            key: 'ent',
            severity: 'error',
            summary: 'Eliminación de Entrada',
            detail: 'Ocurrió un error al reversar la ponderación ' + error
          });
        }
      },
      reject: () => {

      }
    });
  }
}
